import React, {FC} from 'react';
import styled from 'styled-components';

import {
  CreateContactEmailFormFieldModel,
  CreateContactPhoneFormFieldModel,
  CreateContactTwitterHandleFormFieldModel,
} from '../../../../../../../../src/store/panels/contacts/createContactForm/createContactFormState';
import {ContactsManagerPanelId} from '../../../../../../../../src/store/panels/panelStateBase';
import {CreateContactInformationEmailInputContainer} from './createContactInformationEmailInputContainer';
import {CreateContactInformationPhoneInputContainer} from './createContactInformationPhoneInputContainer';
import {CreateContactInformationTwitterInputContainer} from './createContactInformationTwitterInputContainer';

/*
 * Props.
 */

interface CreateContactInformationProps {
  panelId: ContactsManagerPanelId;
  emails: ReadonlyArray<CreateContactEmailFormFieldModel>;
  phoneNumbers: ReadonlyArray<CreateContactPhoneFormFieldModel>;
  twitterHandles: ReadonlyArray<CreateContactTwitterHandleFormFieldModel>;
  isDisabled: boolean;
}

/*
 * Style.
 */

const StyledCreateContactInformationWrapperDiv = styled.div`
  margin-top: 20px;
`;

/*
 * Component.
 */

export const CreateContactInformation: FC<CreateContactInformationProps> = (props) => {
  const {panelId, emails, phoneNumbers, twitterHandles, isDisabled} = props;
  return (
    <StyledCreateContactInformationWrapperDiv>
      {renderEmails(panelId, emails, isDisabled)}
      {renderPhoneNumbers(panelId, phoneNumbers, isDisabled)}
      {renderTwitterHandles(panelId, twitterHandles, isDisabled)}
    </StyledCreateContactInformationWrapperDiv>
  );
};

/*
 * Helpers.
 */

function renderEmails(
  panelId: ContactsManagerPanelId,
  emails: ReadonlyArray<CreateContactEmailFormFieldModel>,
  isDisabled: boolean,
) {
  return emails.map((email, index) => (
    <CreateContactInformationEmailInputContainer
      key={email.uid}
      panelId={panelId}
      email={email}
      isFirst={index === 0}
      isLast={index === emails.length - 1}
      isDisabled={isDisabled}
    />
  ));
}

function renderPhoneNumbers(
  panelId: ContactsManagerPanelId,
  phoneNumbers: ReadonlyArray<CreateContactPhoneFormFieldModel>,
  isDisabled: boolean,
) {
  return phoneNumbers.map((phoneNumber, index) => (
    <CreateContactInformationPhoneInputContainer
      key={phoneNumber.uid}
      panelId={panelId}
      phoneNumber={phoneNumber}
      isFirst={index === 0}
      isLast={index === phoneNumbers.length - 1}
      isDisabled={isDisabled}
    />
  ));
}

function renderTwitterHandles(
  panelId: ContactsManagerPanelId,
  twitterHandles: ReadonlyArray<CreateContactTwitterHandleFormFieldModel>,
  isDisabled: boolean,
) {
  return twitterHandles.map((twitterHandle, index) => (
    <CreateContactInformationTwitterInputContainer
      key={twitterHandle.uid}
      panelId={panelId}
      twitterHandle={twitterHandle}
      isFirst={index === 0}
      isLast={index === twitterHandles.length - 1}
      isDisabled={isDisabled}
    />
  ));
}
